module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "klick-modal"
    }
  }, [_c('div', {
    staticClass: "klick-modal-mask",
    class: _vm.modalTypeClass
  }, [_c('div', {
    staticClass: "klick-modal-wrapper c-modal__wrapper u-scroll"
  }, [(_vm.showCloseButton) ? _c('button', {
    staticClass: "c-modal__close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "c-icon--close"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal__body"
  }, [_vm._t("body")], 2), _vm._v(" "), _vm._t("footer")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6034292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/modal/GeneralLayout.vue
// module id = 321
// module chunks = 22